import React from "react";
import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import {useGlobal} from "reactn";
import {ColoredButton, ButtonText} from "Buttons";
import {Image as ImageComponent} from "BaseComponents/Image";
import {DoubleQuote} from "BaseComponents/Icons/Svg";
import {getButtonColor} from "Helpers/ColorHelper";
import {LazyComponent} from "../../framework/lazy/LazyComponent";
import {getResponsiveImage} from "Helpers/ImageHelper";

export const QuotationListBlock = ({Items}) => {
  return (
    <LazyComponent height="16rem" className='quotationList'>
      {Items.map((x, i) => (
        <QuotationListItem key={`quote-${i}`} {...x} />
      ))}
    </LazyComponent>
  );
};

const QuotationListItem = ({
                             ImageToTheRight,
                             Link,
                             LinkName,
                             ResponsiveImage,
                             Text,
                             TextColor,
                             ButtonColor,
                           }) => {
  const [theme] = useGlobal("theme");

  let Image = getResponsiveImage(ResponsiveImage);
  let alt = ResponsiveImage.Alt;

  const addImageAttributes = alt && alt.length > 0 ? {role: "img", "aria-label": alt} : {"aria-hidden": "true"};

  let innerTextColor = TextColor != "" ? `#${TextColor}` : theme.colors.black;
  let {color, textColor} = getButtonColor(ButtonColor);

  return (
    <QuotationOuterWrapper ImageToTheRight={ImageToTheRight}>
      {Image && (
        <Content>
          <ImageOuterWrapper>
            <ImageWrapper>
              <ImageComponent borderRadius="50%" size="100%" bgImage={Image} {...addImageAttributes} />
            </ImageWrapper>
          </ImageOuterWrapper>
        </Content>
      )}
      <Content>
        <IconWrapper Image={Image}>
          <DoubleQuote color={innerTextColor} margin="0 auto"/>
        </IconWrapper>
        {Text && (
          <Quote
            color={innerTextColor}
            dangerouslySetInnerHTML={{
              __html: Text,
            }}
          ></Quote>
        )}
        {Link && LinkName && (
          <QuoteButtonWrapper>
            <ColoredButton
              href={Link}
              inverted
              bgColor={color}
              minWidth="180px"
              color={textColor}
              margin="0 auto !important"
              smallmargin="0 auto !important"
              padding="0.4rem 1rem"
              smallpadding="0.1rem 1rem"
              aria-label={ButtonText}
            >
              <ButtonText color={textColor} heading={`quote button ${LinkName}`}>{LinkName}</ButtonText>
            </ColoredButton>
          </QuoteButtonWrapper>
        )}
      </Content>
    </QuotationOuterWrapper>
  );
};

const QuotationOuterWrapper = styled.div`
    max-width: 1280px;
    margin: 0 auto;
    padding: 3rem 4rem;
    display: flex;

    ${media.greaterThan(breakpoints.mobile)`
        flex-direction: ${({ImageToTheRight}) =>
            ImageToTheRight ? "row-reverse" : "row"};
    `}

    ${media.lessThan(breakpoints.mobile)`
		flex-direction: column;
        padding: 3rem 1rem;
    `}
`;

const Content = styled.div`
    flex: 1 1 0;
`;

// Icon
const IconWrapper = styled.div`
    display: flex;
    width: 100%;

    ${media.lessThan(breakpoints.mobile)`
        margin: 2rem 0 1rem;
        margin-top: ${({Image}) => (!Image ? "0rem" : "2rem")}
    `}
`;

// Quote text
const Quote = styled.p`
    font-family: ${({theme}) => theme.font};
    margin: 2rem 0 0;

    > * {
        color: ${({theme, color}) => (color ? color : theme.colors.white)};
        margin: 0;
        font-size: 24px;
        line-height: 34px;
    }
`;

// Btn
const QuoteButtonWrapper = styled.div`
    width: 100%;
    display: flex;
    margin-top: 2rem;

    ${media.greaterThan(breakpoints.mobile)`
        padding-bottom: 1rem;
    `}
`;

// Image
const ImageOuterWrapper = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    padding-right: 1rem;
`;

const ImageWrapper = styled.div`
    width: 360px;
    height: 360px;
    margin: auto;
    ${media.lessThan(breakpoints.mobile)`
        width: 200px;
        height: 200px;
    `}
`;
